import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { resolveBucketImageSrc } from '../../../utils/utils'
import iconsList from '../../ui/icons/iconsList'
import Popup from '../../ui/popup/Popup'
import Icon from '../../ui/icons/Icon'
import MessageSenderAvatar from './messageSenderAvatar/MessageSenderAvatar'
import classes from './Message.module.css'

const Message = ({ onDelete, onEdit, ...message }) => {

    const [popupImg, setPopupImg] = useState(null)
    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.MessageWarp}>
            <div className={classes.header}>
                <div className={classes.headerIcons}>
                    {onDelete && <Icon className={classes.Delete} onClick={onDelete} size={15} name={iconsList.delete} />}
                    {onEdit && <Icon className={classes.Edit} onClick={onEdit} size={15} name={iconsList.editElement} />}
                </div>
                {/* <p>{formatHebrewDateTime(message.fromDate)}</p> */}
            </div>
            <div className={classes.Message}>
                <div className={classes.Content}>
                    <MessageSenderAvatar ownerTypeId={message?.ownerTypeId} metadata={message?.metadata} />
                    <div className={classes.MessageContent}>
                        {message?.imageFile && <img
                            className={classes.Img}
                            src={resolveBucketImageSrc(message.imageFile)}
                            alt='messagesImg'
                            onClick={() => setPopupImg(true)}
                        />}
                        {message?.content && <div className={classes.MessageContentText} dangerouslySetInnerHTML={{ __html: message.content }} />}
                    </div>
                </div>

                {popupImg &&
                    <Popup close={() => setPopupImg(false)} dropClass={classes.DropClassPopup} dropClassContainer={classes.DropClassPopupContainer}>
                        <img
                            className={classes.Img}
                            src={resolveBucketImageSrc(message.imageFile)}
                            alt='messagesImg'
                            onClick={() => setPopupImg(true)}
                        />
                    </Popup>}
            </div>
            {(onDelete || onEdit) &&
                <div className={classes.MobileActions}>
                    {onDelete &&
                        <button type="button" className={classes.ActionBtn} onClick={() => onDelete()}>
                            <Icon size={15} name={iconsList.delete} color="#5C5C5C" />
                            <span>{texts.delete}</span>
                        </button>
                    }
                    {onEdit &&
                        <button type="button" className={classes.ActionBtn} onClick={() => onEdit()}>
                            <Icon size={15} name={iconsList.editElement} color="#5C5C5C" />
                            <span>{texts.edit}</span>
                        </button>
                    }
                </div>
            }
        </div>
    )
}

export default Message;